import Axios from 'axios';


let getProductContent = (sku, country) => {
    if (typeof sku != 'string') throw new TypeError(`Expected string, got ${typeof sku}`);
    if (typeof country != 'string') throw new TypeError(`Expected string, got ${typeof country}`);
    if (sku.length !== 8) throw new Error('The length of the string is not 8');
    if (country.length !== 2) throw new Error(`The length of the country must be 2, you gave ${country.length}`);
    // eslint-disable-next-line
    let productServiceURL = "/content/products/" + sku.substring(0,2) + "/" + sku.substring(2,4) + "/" + sku.substring(4,6) + "/" + sku + ".service." + country.toUpperCase() + ".json";


    return Axios.get(productServiceURL, {
        responseType: "json; charset=utf-8"
    });
}

export default {
    getProductContent
}

